<template>
  <v-container grid-list-md fluid class="pa-0">
      <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
        <div class="text-xs-left f-17 text-capitalize">Credit Card & billing Information</div>
      </v-toolbar>
      <v-layout row wrap class=" mt-2">
        <v-flex class="text-xs-center pl-1 pr-1" xs12 sm12 lg6>
          <v-card class="mr-1 text-xs-center transparent card-r no-shadow " color=" ">
            <v-toolbar class="tow-clor-grey card-r mb-3 shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">Billing info</div>
            </v-toolbar>
            <!--<p class="text-xs-left f-15 font-weight-bold">Billing info</p>-->
            <v-container grid-list-md class="pa-0">
              <v-layout row wrap>
                <!-- <v-flex md12 sm12 xs12 class="px-5 checkbox">
                  <v-checkbox
                    v-model="policy"
                    label="Same as my Profile Info"
                    class="input-group--focused mr-5 mt-0 pt-0"
                    color="primary"
                    required
                  ></v-checkbox>
                </v-flex> -->
                <v-flex lg6 xs12 class="">
                  <v-text-field
                    solo
                    name="Full name"
                    label="Full name"
                    v-model="billingInfo.name"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class=" ">
                  <v-text-field
                    solo
                    name="Address"
                    label="Address"
                    type="text"
                    v-model="billingInfo.address"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class="  ">
                  <v-text-field
                    solo
                    name="City"
                    label="City"
                    type="text"
                    v-model="billingInfo.city"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class="  ">
                  <v-text-field
                    solo
                    name="Zip code"
                    label="Zip code"
                    type="text"
                    v-model="billingInfo.zip"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class=" ">
                  <v-text-field
                    solo
                    name="Country"
                    label="Country"
                    type="text"
                    v-model="billingInfo.country"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex class="text-xs-center pl-1 pr-1" xs12 sm12 lg6>
          <v-card class="text-xs-center transparent card-r no-shadow" color=" ">
            <v-toolbar class="tow-clor-grey card-r mb-3 shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">Credit card info</div>
            </v-toolbar>
            <!--<p class="text-xs-left f-15 font-weight-bold">Credit card info</p>-->
            <v-container grid-list-md class="pa-0">
              <v-layout row wrap>
                <!-- <v-flex md12 wrap sm12 xs12 class="  mr-5">
                   <div class="card-type "></div>
                   &lt;!&ndash;<div class="card-type mastercard"></div>&ndash;&gt;
                   &lt;!&ndash;<div class="card-type visa"></div>&ndash;&gt;
                   &lt;!&ndash;<div class="card-type amex"></div>&ndash;&gt;
                   &lt;!&ndash;<div class="card-type discover"></div>&ndash;&gt;
                 </v-flex>-->
                <!--<v-flex xs12 lg6 class=" ">-->

                      <!--<v-text-field-->
                      <!--label="Card Number"-->
                      <!--solo-->
                      <!--placeholder="xxxx - xxxx - xxxx - xxxx"-->
                      <!--mask="credit-card"-->
                      <!--class="feild-height"-->
                      <!--v-model="cardInfo.card_number"-->
                      <!--:disabled="loading"-->
                      <!--required-->
                    <!--&gt;</v-text-field>-->
                  <!--</v-flex>-->
                <!--<v-flex md12 sm12 xs12 lg6 class="">-->
                    <!--<v-text-field solo-->
                            <!--name="Card Holder Name"-->
                            <!--label="Card Holder Name"-->
                            <!--type="text"-->
                            <!--maxlength="30"-->
                            <!--v-model="cardInfo.card_holder_name"-->
                            <!--class="input-group&#45;&#45;focused"-->
                            <!--required-->
                    <!--&gt;</v-text-field>-->
                  <!--</v-flex>-->

                <v-flex md12 sm12 xs12 class="">
                  <v-text-field
                    label="Card Number"
                    solo
                    placeholder="xxxx - xxxx - xxxx - xxxx"
                    :mask="mask"
                    class="feild-height"
                    v-model="cardInfo.card_number"
                    :disabled="loading"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class=" ">
                  <v-text-field
                    solo
                    name="Card Holder Name"
                    label="Card Holder Name"
                    type="text"
                    maxlength="30"
                    v-model="cardInfo.card_holder_name"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 xs12 class=" ">
                  <v-text-field
                    solo
                    name="Expire Date"
                    label="Expire Date"
                    type="text"
                    maxlength="5"
                    placeholder="mm/yy"
                    v-model="cardInfo.expire"
                    class="input-group--focused"
                    required
                    @input="checkdate"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class=" ">
                  <v-text-field
                    solo
                    name="CVV"
                    label="CVV"
                    type="Number"
                    v-model="cardInfo.cvd"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 class=" ">
                  <v-alert
                    :value="true"
                    v-bind:color="error.type[error.code].color"
                    v-bind:icon="error.type[error.code].icon"
                    v-if="errorStatus"
                    outline
                  >
                    {{error.message}}
                  </v-alert>
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                </v-flex>
                <v-flex lg12 xs12 class=" ">
                  <v-btn class="primary darken-2 card-r right" slot="activator" @click="updateCard()" dark>Create</v-btn>
                  <!-- <ConfirmSignup v-bind:value1="'dd'" v-bind:value2="'dd'" v-on:confirmyes="updateCard()"/> -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
  /* eslint-disable */
  import api from "../../../utils/backend-api.js"
  import ConfirmSignup from "../../../components/auth/ConfirmSignup.vue"

  export default {
    components:{
      ConfirmSignup
    },
    name: "AddNewStudent",
    data: () => ({
      billingInfo:{
        name:'',
        address:'',
        city:'',
        zip:'',
        country:'',
      },
      cardInfo:{
        card_number:'',
        card_holder_name:'',
        expire:'',
        cvd:'',
      },
      errorStatus:false,
      error:{
        code:'',
        type:[{icon:"warning",color:'error'},{icon:"check_circle",color:'success'}],
        message:''
      },
      loading:false

    }),
    methods:{
      checkdate(){
        if(this.cardInfo.expire.length==2){
              this.cardInfo.expire=this.cardInfo.expire+'/'
        }
      },
      requiredFields(){
            if(!(this.cardInfo.card_number && this.cardInfo.card_holder_name && this.cardInfo.expire && this.cardInfo.cvd)){
                  this.errorStatus=true
                  this.error.code=0
                  this.error.message="please Fill all the fields"
                  return false
            }else{
              return true
            }
      },
      updateCard(){
        this.loading=true
        this.errorStatus=false
        if(this.requiredFields()){
            let expiration_month=this.cardInfo.expire.substring(0,2)
            let expiration_year=this.cardInfo.expire.substring(3,5)
            let expire={
              expiration_month:this.cardInfo.expire.substring(0,2),
              expiration_year:this.cardInfo.expire.substring(3,7)
            }
            var data={...this.billingInfo,...this.cardInfo,...expire}

            api.postData('admin/change_card',data)
            .then(res=>{
              if(res.status==201){
                this.errorStatus=true
                this.error.code=1
                this.error.message="Successfully updated"
                this.loading=false
              }
            })
            .catch(error=>{
              this.loading=false
              this.errorStatus=true
              this.error.code=0
              this.error.message="Card updation failed. Check your card details"
            })
        }else{
          this.loading=false
        }

      }
    }
  };
</script>
<style>
  .card-type {
    width: 80px;
    height: 56px;
    background: url("../../../assets/cards.png");
    background-position: 0 -291px;
    background-repeat: no-repeat;
  }
  .card-type.mastercard {
    background-position: 0 0;
  }
  .card-type.visa {
    background-position: 0 -115px;
  }
  .card-type.amex {
    background-position: 0 -57px;
  }
  .card-type.discover {
    background-position: 0 -174px;
  }
     /* iPads (portrait and landscape) ----------- */
  /*@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
   /*iPads (landscape) ----------- */
  /*@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
   /*iPads (portrait) ----------- */
  /*@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
   /*iPad 3 ---------------- */
  /*@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
  /*@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
  /**/
   /*Desktops and laptops ----------- */
  /*@media only screen and (min-width : 1224px) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
   /*960px layouts ----------- */
  /*@media only screen and (min-width : 960px){*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
  /**/
   /*Large screens ----------- */
  /*@media only screen and (min-width : 1824px) {*/
    /*.layout.wrap {*/
      /*flex-wrap: wrap!important;*/
    /*}*/
  /*}*/
/**/
</style>



// WEBPACK FOOTER //
// src/components/profile/admin/PaymentMethord.vue